// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-app',
    data: () => ({
        layout: '',
    }),
    computed: {
        _layout() {
            if (!utils.isNullOrEmpty(this._meta?.layout)) {
                return this._meta.layout;
            }
            else {
                return this.$host.config.layoutName;
            }
        },
        _widthMode() {
            if (!utils.isNullOrEmpty(this._meta?.widthMode)) {
                return this._meta.widthMode;
            }
            else {
                return 'default';
            }
        },
        _meta() {
            return this.$route?.meta ?? {};
        }
    },
});
// #endregion
